/**
 * HTML fragments for map sequence leaves in PDF / EPUB (#177).
 */
import { escapeHtmlText } from "./bookTemplate";
import {
  isPreparedMapSpread,
  mapImageForEpub,
  mapImagesForPrint,
  type MapExportImage,
  type PreparedMapFigure,
} from "./mapFigureExport";

function mapImgTag(image: MapExportImage, alt: string): string {
  // Width/height give the print engine an intrinsic box before decode finishes.
  return `<img src="${image.dataUrl}" alt="${escapeHtmlText(alt)}" width="${image.widthPx}" height="${image.heightPx}" />`;
}

/** PDF: single page or verso+recto spread. */
export function mapFigurePdfHtml(prepared: PreparedMapFigure): string {
  const extent = prepared.printExtent;
  const fit = prepared.objectFit;
  const alt = prepared.title;
  const print = mapImagesForPrint(prepared);
  if (print.kind === "spread") {
    return `<section class="map-figure map-figure-spread" data-extent="${extent}" data-fit="${fit}" aria-label="${escapeHtmlText(alt)}">
  <div class="map-page map-verso">${mapImgTag(print.verso, alt)}</div>
  <div class="map-page map-recto">${mapImgTag(print.recto, "")}</div>
</section>`;
  }
  return `<section class="map-figure map-figure-single" data-extent="${extent}" data-fit="${fit}" aria-label="${escapeHtmlText(alt)}">
  <div class="map-page">${mapImgTag(print.image, alt)}</div>
</section>`;
}

/** EPUB: always one zoomable page (ignore spread). */
export function mapFigureEpubHtml(prepared: PreparedMapFigure): string {
  const image = mapImageForEpub(prepared);
  const alt = prepared.title;
  return `<section class="map-figure map-figure-epub" epub:type="bodymatter" aria-label="${escapeHtmlText(alt)}">
  ${mapImgTag(image, alt)}
</section>`;
}

export function mapFigureUsesSpreadPages(prepared: PreparedMapFigure): boolean {
  return isPreparedMapSpread(prepared);
}
